import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';

export const SUPPORTED_LANGUAGES = ['en', 'ar'];
export const normalizeLanguage = (language) => SUPPORTED_LANGUAGES.includes(language?.split('-')[0]) ? language.split('-')[0] : 'en';
export const applyDocumentLocale = (language) => {
  const normalizedLanguage = normalizeLanguage(language);
  document.documentElement.setAttribute('dir', normalizedLanguage === 'ar' ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', normalizedLanguage);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language', // Changed from 'preferredLanguage' to match our store
    },
  });

// Normalize the language to remove region codes (en-US -> en)
const detectedLang = normalizeLanguage(i18n.language);
if (detectedLang !== i18n.language) i18n.changeLanguage(detectedLang);
applyDocumentLocale(detectedLang);

// i18n is the single source of truth for document language and direction.
i18n.on('languageChanged', (lng) => {
  applyDocumentLocale(lng);
});

export default i18n;
